import React from 'react';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { UserGroupIcon } from '@hugeicons-pro/core-bulk-rounded';
import classNames from 'classnames';
import i18n from 'i18next';
import css from './SideBar.module.css';
import logo from '../../../images/logo_96.png';
import SidebarAccountFooter from '../../../components/SidebarAccountFooter/SidebarAccountFooter';
import { AdminBasePath } from '../index';

type MenuItemKey = 'accounts';

const SideBar = () => {
  const history = useHistory();
  const currentKey: MenuItemKey = 'accounts';

  const iconColor = (key: MenuItemKey) => (currentKey === key ? 'var(--primary-color)' : '#64748b');

  const onAccountsClick = () => {
    history.push(AdminBasePath);
  };

  return (
    <div className={css.wrapper}>
      <div className={css.scrollContent}>
        <div className={css.container}>
          <div className={css.brand}>
            <div className={css.brandAvatar}>
              <img src={logo} alt="PingPad" className={css.brandAvatarImg} />
            </div>
            <div className={css.brandText}>
              <div className={css.brandName}>Administration</div>
              <div className={css.brandSub}>PingPad</div>
            </div>
          </div>

          <div className={css.menuDivider} />

          <nav className={css.menu}>
            <Button
              type="text"
              onClick={onAccountsClick}
              className={classNames(css.menuBtn, css.menuRow, { [css.selected]: currentKey === 'accounts' })}
            >
              <HugeiconsIcon icon={UserGroupIcon} size={16} color={iconColor('accounts')} />
              <span>{i18n.t('adminAccounts:title')}</span>
            </Button>
          </nav>
        </div>
      </div>
      <div className={css.footerSlot}>
        <SidebarAccountFooter />
      </div>
    </div>
  );
};

export default SideBar;
